import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
} from '@mui/material';

interface DialogReceiptProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  receiptData: any;
  handleChangeData: (field: string, value: string) => void;
}

const DialogReceipt: React.FC<DialogReceiptProps> = ({
  open,
  onClose,
  onConfirm,
  receiptData,
  handleChangeData,
  
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>領収書情報</DialogTitle>
      <DialogContent>
        <Typography>※宛名、但し、領収日を変更する場合は、書き換えてください</Typography>
        <TextField
          label="宛名"
          fullWidth
          margin="normal"
          value={receiptData.patientName}
          onChange={(e) => handleChangeData('patientName', e.target.value)}
        />
        <TextField
          label="但し"
          fullWidth
          margin="normal"
          value={receiptData.note}
          onChange={(e) => handleChangeData('note', e.target.value)}
        />
        <TextField
          label="領収日"
          fullWidth
          margin="normal"
          value={receiptData.receiptDate}
          onChange={(e) => handleChangeData('receiptDate', e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>キャンセル</Button>
        <Button onClick={onConfirm} variant="contained">
          確定
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogReceipt;
